module.exports = __webpack_public_path__ + "img/2.df8c0747.png";